if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button');
        if (!button || button.dataset.showMoreBound === 'true') return;

        button.dataset.showMoreBound = 'true';
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.expandShowMore(event);
        });
      }

      expandShowMore(event) {
        const parentDisplay =
          this.closest('.parent-display') ||
          event.target.closest?.('.parent-display') ||
          event.target.closest?.('[id^="Show-More-"]')?.closest?.('.parent-display');

        if (!parentDisplay) return;

        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));

        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}
